import { render, staticRenderFns } from "./QuizStudentLeaderBoard.vue?vue&type=template&id=2d461200&"
import script from "./QuizStudentLeaderBoard.vue?vue&type=script&lang=js&"
export * from "./QuizStudentLeaderBoard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports